import { Avatar } from "@mantine/core";

const ClockIcon = ({ size }: any) => {
  return (
    <Avatar
      style={{
        cursor: "pointer",
      }}
      size={size}
      src={"/assets/clockIcon.png"}
    />
  );
};

export default ClockIcon;
